// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { PaymentMethodSelector } from './payment-method-selector';
import { PaymentMethodForm } from './payment-method-form';

type Props = {|
  rootStyle?: {},
|};

export function PaymentMethod({ rootStyle }: Props): Node {
  return (
    <Root style={rootStyle}>
      <PaymentMethodSelector />
      <PaymentMethodForm />
    </Root>
  );
}

const Root = styled.div`
  display: block;
  display: grid;
  grid-gap: 16px;
  &:empty {
    display: none;
  }
`;
